import {clearSession} from "../../../utils/sessionUtils";

// Manual sign-out. Scheduled virtual announcements are backed by the backend and
// re-hydrated on the next login, so they are cleared together with all other
// session data; only per-device recording metadata survives (preserved inside
// clearSession, whose audio blobs live in IndexedDB and are not backed by the
// announcements API).
const Logout = () => {
    clearSession();
    window.location.href = '/#/';
    return null;
}

export default Logout;
